export const basicColors = [
  'black',
  'blue',
  'green',
  'grey',
  'orange',
  'purple',
  'red',
  'teal',
  'yellow',
];

/**
 * - `black` (tailwind `black`) kan gecombineerd worden met witte tekst
 * - `blue` (tailwind `blue`) kan gecombineerd worden met witte tekst
 * - `green` (tailwind `green`) kan gecombineerd worden met zwarte tekst
 * - `grey` (tailwind `grey-200`) kan gecombineerd worden met zwarte tekst
 * - `orange` (tailwind `orange`) kan gecombineerd worden met witte tekst
 * - `purple` (tailwind `purple`) kan gecombineerd worden met witte tekst
 * - `red` (tailwind `red`) kan gecombineerd worden met witte tekst
 * - `teal` (tailwind `teal`) kan gecombineerd worden met witte tekst
 * - `yellow` (tailwind `yellow`) kan gecombineerd worden met zwarte tekst
 */
export type BasicColor = (typeof basicColors)[number];

export const colorTextClasses: Record<BasicColor, string> = {
  black: 'text-black',
  blue: 'text-blue',
  green: 'text-green',
  grey: 'text-grey-200',
  orange: 'text-orange',
  purple: 'text-purple',
  red: 'text-red',
  teal: 'text-teal',
  yellow: 'text-yellow',
};

const opacityLevels = ['default', '75', '50', '25', '10'] as const;

export type OpacityLevel = (typeof opacityLevels)[number];

export type OpacityClasses = {
  [L in OpacityLevel]: string;
};
export const colorBgClasses: Record<BasicColor, OpacityClasses> = {
  black: {
    default: 'bg-black',
    '75': 'bg-black/75',
    '50': 'bg-black/50',
    '25': 'bg-black/25',
    '10': 'bg-black/10',
  },
  blue: {
    default: 'bg-blue',
    '75': 'bg-blue/75',
    '50': 'bg-blue/50',
    '25': 'bg-blue/25',
    '10': 'bg-blue/10',
  },
  green: {
    default: 'bg-green',
    '75': 'bg-green/75',
    '50': 'bg-green/50',
    '25': 'bg-green/25',
    '10': 'bg-green/10',
  },
  grey: {
    default: 'bg-grey-200',
    '75': 'bg-grey-200/75',
    '50': 'bg-grey-200/50',
    '25': 'bg-grey-200/25',
    '10': 'bg-grey-200/10',
  },
  orange: {
    default: 'bg-orange',
    '75': 'bg-orange/75',
    '50': 'bg-orange/50',
    '25': 'bg-orange/25',
    '10': 'bg-orange/10',
  },
  purple: {
    default: 'bg-purple',
    '75': 'bg-purple/75',
    '50': 'bg-purple/50',
    '25': 'bg-purple/25',
    '10': 'bg-purple/10',
  },
  red: {
    default: 'bg-red',
    '75': 'bg-red/75',
    '50': 'bg-red/50',
    '25': 'bg-red/25',
    '10': 'bg-red/10',
  },
  teal: {
    default: 'bg-teal',
    '75': 'bg-teal/75',
    '50': 'bg-teal/50',
    '25': 'bg-teal/25',
    '10': 'bg-teal/10',
  },
  yellow: {
    default: 'bg-yellow',
    '75': 'bg-yellow/75',
    '50': 'bg-yellow/50',
    '25': 'bg-yellow/25',
    '10': 'bg-yellow/10',
  },
};

export function getBgClass(color: BasicColor, opacity: OpacityLevel = 'default'): string {
  // Valideer kleur
  const entry = colorBgClasses[color];
  if (!entry) return '';

  // Valideer opacity; fallback op 'default' als de key ontbreekt
  if (!(opacity in entry)) return entry.default;

  return entry[opacity];
}
